  <div class="row">
    <div class="col">
      <h3>Distribuição de limites - Tarefas</h3>
    </div>
  </div>

<section class="container">
  <div ngbAccordion>
  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title1">Geração da prévia</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="bn-form-group row">
            <div class="col-md-6">
              <div
                class="col-md-12"
                *ngIf="apuracaoRenunciaDto?.totalPorBimestre > 0"
              >
                <label for="idOperacao">Bimestre de apuração renúncia:</label>
                <input
                  type="text"
                  class="form-control"
                  disabled
                  [(ngModel)]="apuracaoRenunciaDto.bimestre"
                />
              </div>
              <div class="col-md-12">
                <label for="idOperacao">
                  Valor total do novo limite de contratação
                  <strong *ngIf="apuracaoRenunciaDto?.totalPorBimestre > 0"
                    >sem renúncia:
                  </strong>
                  <i
                    class="fa fa-question-circle help-subtitulo"
                    placement="bottom"
                    *ngIf="apuracaoRenunciaDto?.totalPorBimestre > 0"
                    ngbTooltip="Valor total do novo limite de contratação excluindo o valor acumulado de renúncia do bimestre 1 até o bimestre atual"
                  ></i>
                </label>
                <input
                  type="text"
                  class="form-control"
                  bnMask="MOEDA"
                  [(ngModel)]="valorTotalNovoLimiteContratacao"
                  (ngModelChange)="
                    atualizaValor(apuracaoRenunciaDto?.totalPorBimestre)
                  "
                />
              </div>
            </div>
            <div
              class="col-md-6"
              *ngIf="apuracaoRenunciaDto?.totalPorBimestre > 0"
            >
              <div class="col-md-12">
                <label for="idOperacao"
                  >Valor total renunciado descomprometido apurado:
                  <i
                    class="fa fa-question-circle help-subtitulo"
                    placement="bottom"
                    ngbTooltip="Valor acumulado de renúncia do bimestre 1 até o bimestre atual"
                  ></i>
                </label>
                <input
                  type="text"
                  class="form-control"
                  disabled
                  bnMask="MOEDA"
                  [(ngModel)]="apuracaoRenunciaDto.totalPorBimestre"
                />
              </div>
              <div class="col-md-12">
                <label for="idOperacao" class="label-verde"
                  >Valor total do novo limite de contratação:</label
                >
                <input
                  type="text"
                  class="form-control"
                  disabled
                  bnMask="MOEDA"
                  [(ngModel)]="novoValor"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-auto" style="margin-top: 10px">
              <button
                #focusableSubmit
                type="button"
                class="btn btn-success no-margin"
                [disabled]="!valorTotalNovoLimiteContratacao"
                (click)="executarPrevia()"
              >
                Executar prévia
              </button>
            </div>

            <div class="col-auto" style="margin-top: 10px">
              <button type="button" class="btn btn-light" (click)="limpar()">
                Limpar
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem *ngIf="!(ambientePrd$ | async)">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">
        Distribuição de limites
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-auto" style="margin-top: 10px">
              <button
                #focusableSubmit
                type="button"
                class="btn btn-success no-margin"
                (click)="executarDistribuicao()"
              >
                Executar distribuição de limites
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  </div>
</section>
